import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  AddLinkObject,
  Links,
  ChangeLinkObject,
  Link,
} from "./links.interface";
import { AddonsResponse, TypedAddon } from "../addons.interface";
import { map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class LinksService {
  constructor(private http: HttpClient) {}

  getLinks = (): Observable<Links> => {
    return this.http.get<AddonsResponse>("/addons").pipe(
      map((addons) =>
        addons?.LINK?.map((link) => ({
          addonId: link.addonId,
          modifiedAt: link.modifiedAt,
          isUsed: link.isUsed,
          usedInSignatures: link.usedInSignatures ?? [],
          ...link.data,
        })),
      ),
      map((links) => ({ links })),
    );
  };

  getLinkById = (addonId: string): Observable<Link> => {
    return this.getLinks().pipe(
      map((links) => links.links.find((link) => link.addonId === addonId)),
    );
  };

  changeLink = (body: ChangeLinkObject): Observable<unknown> => {
    return this.http.put(`/addons/${body.addonId}`, body);
  };

  removeLink = (addonId: string): Observable<unknown> => {
    return this.http.delete(`/addons/${addonId}`);
  };

  addLink = (payload: AddLinkObject): Observable<Link> => {
    return this.http.post<TypedAddon<Link>>(`/addons`, payload).pipe(
      map((link) => ({
        addonId: link.addonId,
        ...link.data,
      })),
    );
  };
}
